import React from 'react';

import { Input, InputGroup, Icon } from 'rsuite';

import Config from '../../config/Config'
import Cache from '../../frame/Cache';
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetTable from '../../widget/WidgetTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetComponent from './../../widget/WidgetComponent';

import 'antd/dist/antd.css';

class DepartmentUser extends WidgetComponent
{
    constructor( props )
    {
        super(props);

        let path, department;

        path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        if( this.props.location!==undefined && this.props.location.state!==undefined )
        {
            department = this.props.location.state.department;
        }

        this.state = {
            path : path,
            userData : undefined,
            department : department!==undefined ? department : {},
            keyWord : undefined,
            data : undefined,
            total : undefined,
            options : {
                records : 10
            },
            columns:[
                { name: 'UID', title: '用户UID', type: 'string', description: '用户UID', properties: { hidden: true }},
                { name: 'username', title: '用户名称', type: 'string', description: '用户名称', properties: { hidden: false }},
                { name: 'realname', title: '用户姓名', type: 'string', description: '用户姓名', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [ { name: '删除', click: "removeUser"} ]
                    }
                }
            ],
            userName:undefined,
            removeUser :undefined,
            departmentAddUserTotal : undefined,
            departmentAddUserData : undefined,
            departmentAddUserColumns:[
                { name: 'UID', title: '用户UID', type: 'string', description: '用户UID', properties: { hidden: true }},
                { name: 'username', title: '用户名称', type: 'string', description: '用户名称', properties: { hidden: false }},
                { name: 'realname', title: '用户姓名', type: 'string', description: '用户姓名', properties: { hidden: false }},
            ],
            departmentAddUserOptions : {
                records : 10,
                check : { name:"UID" }
            },
            departmentAddUserNodelOptions : {
                title : "添加用户",
                cancel : "关闭",
                size : 'lg'
            },
            messageOptions : {
                title : "信息",
            }
        };
        
        this.onEvent = this.onEvent.bind(this);

        this.addUser = this.addUser.bind(this);
        this.checkUser = this.checkUser.bind(this);
        this.userSubmit = this.userSubmit.bind(this);
        this.onUserSubmit = this.onUserSubmit.bind(this);

        this.removeUser = this.removeUser.bind(this);
        this.onRemoveUser = this.onRemoveUser.bind(this);
        this.removeUserConfirm = this.removeUserConfirm.bind(this);
        
        this.pageTurning = this.pageTurning.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        
        this.pageUserTurning = this.pageUserTurning.bind(this);

        this.departmentUserSearch = this.departmentUserSearch.bind(this);
        this.onDepartmentUserSearch = this.onDepartmentUserSearch.bind(this);

        this.userNameKeyUp = this.userNameKeyUp.bind(this);
        this.userNameOnChange = this.userNameOnChange.bind(this);
        
        this.departmentNoUserSearch = this.departmentNoUserSearch.bind(this);
        this.onDepartmentNoUserSearch = this.onDepartmentNoUserSearch.bind(this);

        this.redrict = this.redrict.bind(this);
    }

    componentDidMount()
    {
        this.departmentUserSearch(1);
    }

    departmentAddUserRef = ( ref ) => {
        this.departmentAddUserRef = ref;
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }

    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange(value, event)
    {
        this.setState({keyWord:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.departmentUserSearch();
        }
    }

    /**
     * 部门用户搜索函数
     */
    departmentUserSearch( page )
    {
        const { path, keyWord, options, department } = this.state;

        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            id : department.id,
            state : 1, 
            exist : true,
            page : page,
            records : options.records
        };

        if( keyWord!==undefined )
        {
            params["name"] = keyWord;
        }

        WidgetAjax.ajax({url:path + 'group/search_user', params:params, callback:this.onDepartmentUserSearch});
    }

    /**
     * 部门搜索回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onDepartmentUserSearch( result, params )
    {
        if( result.status===0 )
        {
            let { options } = this.state;

            options["page"] = params.page;

            this.setState({data:result.results, total:result.total, options:options});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.departmentUserSearch(page);
    }

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }

        switch( type )
        {
            case "removeUser":
            {
                this.removeUser(data);
                break;
            }
            default:
                break;
        }
    }

    /**
     * 移除用户
     */
    removeUser( data )
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要移除用户 '` + data.realname +`' 吗? ` ;
        messageOptions["confirmFunction"] = this.removeUserConfirm;
        
        this.state["removeUser"] = data;

        this.state["messageOptions"] = messageOptions;

        this.messageRef.open();
    }

    removeUserConfirm()
    {
        const { removeUser, department, path } = this.state;

        if( removeUser!==undefined )
        {
            let params = {
                id : department.id,
                UID : removeUser.UID,
                realname: removeUser.realname
                
            };

            WidgetAjax.ajax({url:path + 'group/remove_user', params:params, callback:this.onRemoveUser});
        }
    }

    /**
     * 移除用户的回调
     */
    onRemoveUser(result, params )
    {
        const { messageOptions } = this.state;

        messageOptions["isMessage"] = true ;

        if( result.status===0 )
        {
            messageOptions["message"] = "用户 '" + params.realname +"' 移除成功！" ;

            this.departmentUserSearch(1);

            this.messageRef.open();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
     userNameOnChange(value, event)
    {
        this.setState({userName:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    userNameKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.departmentNoUserSearch();
        }
    }

    /**
     * 部门外用户搜索函数
     */
    departmentNoUserSearch( page )
    {
        const { path, userName, options, department } = this.state;

        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            id : department.id,
            state : 1, 
            exist : false,
            page : page,
            records : options.records
        };

        if( userName!==undefined )
        {
            params["name"] = userName;
        }

        WidgetAjax.ajax({url:path + 'group/search_user', params:params, callback:this.onDepartmentNoUserSearch});
    }
 
    /**
    * 部门外用户搜索回调函数
    * @param {*} result 
    * @param {*} params 
    */
    onDepartmentNoUserSearch( result, params )
    {
        if( result.status===0 )
        {
            let { departmentAddUserOptions } = this.state;

            departmentAddUserOptions["page"] = params.page;

            this.setState({departmentAddUserData:result.results, departmentAddUserTotal:result.total, options:departmentAddUserOptions});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    pageUserTurning( page )
    {
        this.departmentNoUserSearch(page);
    }

    checkUser( data )
    {
        this.setState({userData: data});
    }

    /**
     * 添加用户
     */
    addUser()
    {
        this.departmentNoUserSearch(1);

        this.departmentAddUserRef.open();
    }

    /**
     * 添加用户提交
     */
    userSubmit()
    {
        const { userData, department, path } = this.state;

        let params = {
            id : department.id
        };

        if( userData!==undefined && userData.length>0 )
        {
            for( let item of userData )
            {
                params["UID"] = item.UID;
                params["realname"] = item.realname;

                WidgetAjax.ajax({url:path + 'group/add_user', params:params, callback:this.onUserSubmit});
            }
        }
    }

    /**
     * 添加用户回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onUserSubmit( result, params )
    {
        const { messageOptions } = this.state;
        messageOptions["isMessage"] = true ;

        if( result.status===0 )
        {
            messageOptions["message"] = "用户 '" + params.realname +"' 添加成功！" ;

            this.departmentUserSearch(1);
            this.departmentNoUserSearch(1);

            this.messageRef.open();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 跳转
     */
    redrict()
    {
        this.props.history.push('/home/department');
    }


    render()
    {
        const { columns, data, total, keyWord, options, messageOptions, department, 
            departmentAddUserNodelOptions,  departmentAddUserOptions, departmentAddUserColumns, departmentAddUserData, departmentAddUserTotal} = this.state;

        return (
            <div className="page ">
                <div className="page-weidu">
                    <div className="page-title">
                        <div className="page-title-img"><img src={require("./img/ml-ztzt.png")} alt=""></img></div>
                        <span className="page-title-font button" onClick={this.redrict}> 用户部门管理 </span> / <span className="page-title-path-font">{department.name}</span>
                    </div>
                </div>
                
                <div className="page-content page-overflow" >
                    <div className="content-canvas content-top-frame-height height-100">
                        <div className="content-title Addroles">
                            <div className="button">
                                <span className="addUser click" onClick={this.addUser}>添加用户</span>
                            </div>
                            <div className="search">
                                <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入搜索内容" onChange={this.keyWordOnChange } onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" onClick={this.departmentUserSearch} /></InputGroup.Addon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="content-chart-height content-table">
                            <WidgetTable options={options} columns={columns} data={data} total={total} notify={this.onEvent} pageTurning={this.pageTurning}></WidgetTable>
                        </div>
                    </div>
                </div>

                <WidgetModal options={departmentAddUserNodelOptions} onRef={this.departmentAddUserRef} >
                    <div className="model adddepart">
                        <div className="page-content page-overflow" >
                            <div className="content-canvas content-top-frame-height height-100">
                                <div className="content-title Addroles">
                                    <div className="button">
                                        <span className="addUser" onClick={this.userSubmit}>提交</span>
                                    </div>
                                    <div className="search">
                                        <InputGroup className="InputGroup"  >
                                            <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入搜索内容" onChange={this.userNameOnChange } onKeyUp={this.userNameKeyUp} />
                                            <InputGroup.Addon><Icon icon="search" onClick={this.departmentNoUserSearch} /></InputGroup.Addon>
                                        </InputGroup>
                                    </div>
                                </div>

                                <div className="content-chart-height content-table">
                                    <WidgetTable options={departmentAddUserOptions} columns={departmentAddUserColumns} data={departmentAddUserData} 
                                        total={departmentAddUserTotal} notify={this.onEvent} pageTurning={this.pageUserTurning} onCheck={ this.checkUser }  ></WidgetTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </WidgetModal>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default DepartmentUser
